import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  StyledLabel,
  StyledBoxInputSkill,
  StyledBoxModule,
  StyledOrderItemSkill,
  StyledIcon,
  StyledBoxTwoModules
} from './style';
import { getEducationsCategory2 } from '../../../../utils/apiDataUserForm';

import DropdownInput from '../../../core/DropdownInput';
import { TRAINING } from '../../../../constants/literals/modals';
import { Trash } from '../../../../../assets/images/index';

const TrainingNeedsItem = ({
  trainingId,
  trainingData,
  order,
  onClickDown,
  onClickUp,
  onClickDelete,
  onChangeTraining,
  className
}) => {
  const [trainingList, setTrainingList] = useState(null);
  const [currentTraining, setCurrentTraining] = useState(null);

  useEffect(() => {
    const trainingIds = trainingData && trainingData.map(a => a.trainingId);
    getEducationsCategory2(9).then(trainings => {
      const trainingListUpdated =
        trainingIds && trainings.filter(i => !trainingIds.includes(i.id));
      setTrainingList(trainingListUpdated);
      if (trainingId) {
        setCurrentTraining(trainings.filter(t => t.id === trainingId)[0].name);
      }
    });
  }, [trainingId, trainingData]);

  return (
    <StyledBoxModule className={className}>
      <StyledOrderItemSkill
        order={order}
        onClickDown={onClickDown}
        onClickUp={onClickUp}
      />
      <StyledBoxTwoModules>
        <StyledBoxInputSkill
          className={`${currentTraining ? 'skill-input' : ''}`}
        >
          <StyledLabel>{TRAINING.CATEGORY}</StyledLabel>
          {trainingList && (
            <DropdownInput
              className="form-dropdown"
              list={trainingList}
              label={currentTraining || 'Seleccionar Formación'}
              onSelect={e => {
                onChangeTraining(e);
              }}
            />
          )}
        </StyledBoxInputSkill>
      </StyledBoxTwoModules>
      <StyledIcon
        className="icon-trash"
        svg={Trash}
        hover
        onClick={onClickDelete}
      />
    </StyledBoxModule>
  );
};

TrainingNeedsItem.propTypes = {
  trainingId: PropTypes.number,
  trainingData: PropTypes.arrayOf(
    PropTypes.shape({
      trainingId: PropTypes.number,
      training: PropTypes.string
    })
  ),
  order: PropTypes.number,
  onClickDown: PropTypes.func,
  onClickUp: PropTypes.func,
  onChangeTraining: PropTypes.func,
  onClickDelete: PropTypes.func,
  className: PropTypes.string
};

TrainingNeedsItem.defaultProps = {
  order: 0,
  className: ''
};

export default TrainingNeedsItem;
